/*-------------------------------------------------
	Logo Zoom
-------------------------------------------------*/
(function(){
    'use strict';

    var logo      = document.querySelector('.un_hdrLogo');
    var threshold = 10;

    if (!logo) return;

    function onScroll() {
        if (window.scrollY >= threshold) {
            logo.classList.add('small');
        } else {
            logo.classList.remove('small');
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // 初期状態にも対応（リロード時など）
})();

/*-------------------------------------------------
	Hamburger Menu
-------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.un_btn_hbg');
  const nav = document.querySelector('.ly_gNav');

  btn.addEventListener('click', function () {
    btn.classList.toggle('active');
    nav.classList.toggle('active');
    document.body.classList.toggle('hp_noScroll');
  });
});